import HttpService from "./htttp.service";

class StatsService {
  // StatsEndpoint = process.env.API_URL;

  getStats = async () => {
    const getStats = "dash/stats/supplier";
    return await HttpService.get(getStats);
  };

  // getStatsByAge = async () => {
  //   const getStatsByAge = "dash/stats/stats_by_age";
  //   return await HttpService.get(getStatsByAge);
  // };

  getStatsClientsJoinedPerMonth = async () => {
    const getStatsClientsJoinedPerMonth = "dash/stats/clients_joined_per_month";
    return await HttpService.get(getStatsClientsJoinedPerMonth);
  };

  getStatsNewOrdersPerMonth = async () => {
    const getStatsNewOrdersPerMonth = "dash/stats/new_orders_per_month";
    return await HttpService.get(getStatsNewOrdersPerMonth);
  };

  getTopPerformingProSupSerCom = async () => {
    const getTopPerformingProSupSerCom =
      "dash/stats/top_performing_pro_sup_ser_com";
    return await HttpService.get(getTopPerformingProSupSerCom);
  };

  getOverallSupplierStats = async () => {
    const getOverallSupplierStats = "dash/stats/overall";
    return await HttpService.get(getOverallSupplierStats);
  };
}

export default new StatsService();
